import * as React from 'react';
import icon from '../../assets/img/flags/michigan.svg';

export const Michigan = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
